/**
 * Persist the signed-in user's Lexicanon theme override (or null to clear it
 * and fall back to the workspace default, then the global default). Hits the
 * shared theme-preference endpoint; the backend checks the value against the
 * full theme set. The workspace default is saved with branding, not here.
 */

import { asLexThemeKey, type TLexThemeKey } from "@lexicanon/shared"
import { api } from "./client.ts"
import { unwrap } from "./errors.ts"

/** Set (or clear, with null) the signed-in user's personal theme override. */
export async function updateLexThemePreference(theme: TLexThemeKey | null): Promise<TLexThemeKey | null> {
  const response = unwrap(await api.api.users.me.theme.put({ theme }))
  // The shared endpoint can also hold Voxcanon values; coerce to a Lex key.
  return asLexThemeKey(response.data.theme)
}
